import {Claims, SuccessPayload, User} from '@teamhanko/hanko-elements';

export type OnSuccessFn = (payload: SuccessPayload | null) => Promise<void>;

export type SopiHankoOptions = {
    hankoUrl: string;
    apiUrl: string;
    loginCheckApiUrl: string;
    logoutApiUrl: string;
    loginRoute: string;
    // postLoginRoute: string;
    successFn : OnSuccessFn
}


export type MyIdentity = {
    identityId: string;
    mail: string;
    isSystemAdmin: boolean;
}

// claims, die wir in hanko selber einfügen
// Aktuell verwendet: SystemAdmin
export type CustomClaims = Claims<{
    roles?: string[];
}>;


export type LogoutExternalClient = {
    type: string;
    client_id: string;
}

export type LogoutApiResponse = {
    external_clients: LogoutExternalClient[]
}

export type LoginCheckApiResponse = {
    use_entra_id: boolean;
    trusted_required: boolean;
    entra_id_domain?: string;
}


// metadaten die wir von der anwendung setzen, wo der Benutzer angelegt wird
// z.b. orga-app
export type MyUserMetadata = {
    created: {
        env: string;  // dev, prod
        sys: string; // orga-app, teamorga, ...
        tenant_id: string; // tenant aus dem sys, der den user anlegt
        trusted_required: string; // gibt an, ob am mandanten trusted required ist, wenn ja, sollte der prozess angestossen werden
    },
    role: string
}


// hilfs funktion, die die metadaten prüft, ob beim angelegten system+tenant trusted erforderlich ist
export function tenantNeedsTrustedUser(user: User) {
    const userMeta = user?.metadata?.public_metadata as MyUserMetadata;
    return userMeta?.created?.trusted_required?.toLowerCase() === 'true';
}

// checkt ob am user bereits multi faktor eingerichtet ist
export function userHasMfaEnabled(user: User) {
    return user?.mfa_config?.auth_app_set_up === true;
}

// checkt ob der benutzer einen microsoft account verknüpft hat.
// microsoft account zählt als trusted
export function userHasMicrosoftLinked(user: User) {
    if (user && user.emails) {

        for (const email of user.emails) {
            // console.log('email:', email);

            if (email.identities) {
                for (const identity of email.identities) {
                    // console.log('identity:', identity);

                    if (identity.provider === 'Microsoft') {
                        return true;
                    }

                }
            }
        }
    }

    return false;
}

export function createMyIdentityFromClaims(claims: CustomClaims): MyIdentity {
    // console.log('createMyIdentityFromClaims', 'claims:', claims);

    let mail: string | null = null;
    if (claims.email) {
        mail = claims.email["address"];
    }

    return {
        identityId: claims.subject,
        mail,
        isSystemAdmin: claims.roles?.includes('SystemAdmin') ?? false
    }

}

export function createMyIdentityFromUser(user: User): MyIdentity {
    // console.log('createMyIdentityFromUser', 'user:', user);
    const userMeta = user?.metadata?.public_metadata as MyUserMetadata;

    const mail = user.emails?.find(x=> x.is_primary)?.address;

    return {
        identityId: user.user_id,
        mail,
        isSystemAdmin: userMeta?.role === 'SystemAdmin'
    }

}
